'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'
import useGoogleAnalytics from './use-google-analytics'

export const useTrackPageView = () => {
  const pathname = usePathname()
  const GA = useGoogleAnalytics()
  const previousPathRef = useRef<string | null>(null)

  useEffect(() => {
    if (pathname && pathname !== previousPathRef.current) {
      GA.pageView(pathname)
      previousPathRef.current = pathname
    }
  }, [GA, pathname])
}
